import { Icon } from '@hologram-dimension/icon';
import { Popover } from '@hologram-dimension/popover';
import { useId, type FC, type ReactNode } from 'react';
import * as LogAuthTypes from '../constants/logAuthTypes';

interface LogAuthTypeIndicatorProps {
  type: (typeof LogAuthTypes)[keyof typeof LogAuthTypes];
}

const LogAuthTypeIndicator: FC<LogAuthTypeIndicatorProps> = ({ type = LogAuthTypes.NONE }) => {
  let tooltipContent: ReactNode;
  let typeName: string | null;

  switch (type) {
    case LogAuthTypes.OTP:
      tooltipContent = (
        <>
          <strong>OTP Verified:</strong>
          Message authenticated by Hologram OTP.
        </>
      );
      typeName = 'OTP';
      break;
    case LogAuthTypes.MULTI_FACTOR:
      tooltipContent = (
        <>
          <strong>Multi-factor Verified:</strong>
          Message authenticated by Hologram OTP-M hardware factor.
        </>
      );
      typeName = 'MFA';
      break;
    case LogAuthTypes.KEY:
      tooltipContent = (
        <>
          <strong>Device Key Verified:</strong>
          Message authenticated by Hologram device key.
        </>
      );
      typeName = 'KEY';
      break;
    default:
      tooltipContent = null;
      typeName = null;
  }

  const popoverId = useId();

  return tooltipContent && typeName ? (
    <div className="log-auth-type">
      <Popover id={popoverId} content={tooltipContent}>
        <Icon name="Lock" size="small" />
        {typeName}
      </Popover>
    </div>
  ) : null;
};

export default LogAuthTypeIndicator;
